import { render, staticRenderFns } from "./o-footer.vue?vue&type=template&id=46e1b79a&scoped=true&"
import script from "./o-footer.vue?vue&type=script&lang=js&"
export * from "./o-footer.vue?vue&type=script&lang=js&"
import style0 from "./o-footer.vue?vue&type=style&index=0&id=46e1b79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e1b79a",
  null
  
)

export default component.exports